import { render } from "./ModalSplit.vue?vue&type=template&id=3c94d924"
import script from "./ModalSplit.vue?vue&type=script&lang=js"
export * from "./ModalSplit.vue?vue&type=script&lang=js"

import "./ModalSplit.vue?vue&type=style&index=0&id=3c94d924&lang=css"
script.render = render

export default script